import _Set from "./internal/_Set.js";
import _curry2 from "./internal/_curry2.js";
var uniqBy = _curry2(function uniqBy(fn, list) {
    var set = new _Set();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while (idx < list.length) {
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) {
            result.push(item);
        }
        idx += 1;
    }
    return result;
});
export default uniqBy;
